<form class="space-y-md" [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <!-- Age -->
  <div class="gradual-reveal mt-2xl space-y-md">
    <label class="mt-xs font-bold">{{ t('createJobRequest.parquetMaintenance.sizeOfFloor.label') }}</label>
    <cft-number-input
      [formControl]="form.controls.sizeOfFloor | bgoAsFormControl"
      [min]="0"
      [max]="200"
      [step]="5"
      class="mt-xs block"
    />
    @if (form.controls.sizeOfFloor.invalid && form.controls.sizeOfFloor.touched) {
      <div class="mb-md error">{{ t('createJobRequest.parquetMaintenance.sizeOfFloor.error') }}</div>
    }
  </div>

  <!-- Wear and Tear -->
  <div class="space-y-md" [class.gradual-reveal-hidden]="form.controls.sizeOfFloor.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.parquetMaintenance.condition.label') }}</label>
    <cft-radio
      [name]="'condition'"
      [hasWarning]="form.controls.condition.invalid && form.controls.condition.touched"
      [value]="ParquetMaintenance_ParquetCondition.NormalWearAndTear"
      formControlName="condition"
      >{{ t('createJobRequest.parquetMaintenance.condition.normal') }}</cft-radio
    >
    <cft-radio
      [name]="'condition'"
      [hasWarning]="form.controls.condition.invalid && form.controls.condition.touched"
      [value]="ParquetMaintenance_ParquetCondition.HeavyWearAndTear"
      formControlName="condition"
      >{{ t('createJobRequest.parquetMaintenance.condition.heavy') }}</cft-radio
    >
    <cft-radio
      [name]="'condition'"
      [hasWarning]="form.controls.condition.invalid && form.controls.condition.touched"
      [value]="ParquetMaintenance_ParquetCondition.WaterDamage"
      formControlName="condition"
      >{{ t('createJobRequest.parquetMaintenance.condition.waterDamage') }}</cft-radio
    >
  </div>

  <!-- Has Been Sanded -->
  <div class="gradual-reveal mt-2xl space-y-md" [class.gradual-reveal-hidden]="form.controls.condition.invalid">
    <label class="mt-xs font-bold">{{ t('createJobRequest.parquetMaintenance.hasBeenSandedBefore.label') }}</label>
    <div class="space-y-md">
      <cft-radio
        [name]="'hasBeenSandedBefore'"
        [hasWarning]="form.controls.hasBeenSandedBefore.invalid && form.controls.hasBeenSandedBefore.touched"
        [value]="true"
        formControlName="hasBeenSandedBefore"
        >{{ t('createJobRequest.parquetMaintenance.hasBeenSandedBefore.yes') }}
      </cft-radio>
      <cft-radio
        [name]="'hasBeenSandedBefore'"
        [hasWarning]="form.controls.hasBeenSandedBefore.invalid && form.controls.hasBeenSandedBefore.touched"
        [value]="false"
        formControlName="hasBeenSandedBefore"
        >{{ t('createJobRequest.parquetMaintenance.hasBeenSandedBefore.no') }}
      </cft-radio>
    </div>
  </div>

  <!-- Accessibility -->
  <div
    class="gradual-reveal mt-2xl space-y-md"
    [class.gradual-reveal-hidden]="form.controls.hasBeenSandedBefore.invalid"
  >
    <label class="mt-xs font-bold">{{
      t('createJobRequest.parquetMaintenance.areThereObstaclesOnTheFloor.label')
    }}</label>
    <div class="space-y-md">
      <cft-radio
        [name]="'areThereObstaclesOnTheFloor'"
        [hasWarning]="
          form.controls.areThereObstaclesOnTheFloor.invalid && form.controls.areThereObstaclesOnTheFloor.touched
        "
        [value]="true"
        formControlName="areThereObstaclesOnTheFloor"
        >{{ t('createJobRequest.parquetMaintenance.areThereObstaclesOnTheFloor.yes') }}
      </cft-radio>
      <cft-radio
        [name]="'areThereObstaclesOnTheFloor'"
        [hasWarning]="
          form.controls.areThereObstaclesOnTheFloor.invalid && form.controls.areThereObstaclesOnTheFloor.touched
        "
        [value]="false"
        formControlName="areThereObstaclesOnTheFloor"
        >{{ t('createJobRequest.parquetMaintenance.areThereObstaclesOnTheFloor.no') }}
      </cft-radio>
    </div>

    <!-- glued ? -->
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="form.controls.areThereObstaclesOnTheFloor.invalid"
    >
      <label class="mt-xs font-bold">{{ t('createJobRequest.parquetMaintenance.areSkirtingBoardsGlued.label') }}</label>
      <div class="space-y-md">
        <cft-radio
          [name]="'areSkirtingBoardsGlued'"
          [hasWarning]="form.controls.areSkirtingBoardsGlued.invalid && form.controls.areSkirtingBoardsGlued.touched"
          [value]="true"
          formControlName="areSkirtingBoardsGlued"
          >{{ t('createJobRequest.parquetMaintenance.areSkirtingBoardsGlued.yes') }}
        </cft-radio>
        <cft-radio
          [name]="'areSkirtingBoardsGlued'"
          [hasWarning]="form.controls.areSkirtingBoardsGlued.invalid && form.controls.areSkirtingBoardsGlued.touched"
          [value]="false"
          formControlName="areSkirtingBoardsGlued"
          >{{ t('createJobRequest.parquetMaintenance.areSkirtingBoardsGlued.no') }}
        </cft-radio>
      </div>
    </div>

    <!-- length of skirting board -->
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="form.controls.areSkirtingBoardsGlued.invalid"
    >
      <label class="mt-xs font-bold">{{ t('createJobRequest.parquetMaintenance.skirtingBoardLength.label') }}</label>
      <cft-number-input
        [formControl]="form.controls.skirtingBoardLength | bgoAsFormControl"
        [min]="0"
        [max]="200"
        [step]="1"
        class="mt-xs block"
      />
      @if (form.controls.skirtingBoardLength.invalid && form.controls.skirtingBoardLength.touched) {
        <div class="mb-md error">{{ t('createJobRequest.parquetMaintenance.skirtingBoardLength.error') }}</div>
      }
    </div>

    <!-- Material -->
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="form.controls.skirtingBoardLength.invalid"
    >
      <label class="mt-xs font-bold">{{ t('createJobRequest.parquetMaintenance.material.label') }}</label>
      <cft-form-field>
        <input [formControl]="form.controls.material | bgoAsFormControl" id="from" type="text" />
      </cft-form-field>
    </div>

    <!-- Age -->
    <div
      class="gradual-reveal mt-2xl space-y-md"
      [class.gradual-reveal-hidden]="form.controls.skirtingBoardLength.invalid"
    >
      <label class="mt-xs font-bold">{{ t('createJobRequest.parquetMaintenance.age.label') }}</label>
      <cft-number-input
        [formControl]="form.controls.age | bgoAsFormControl"
        [min]="1"
        [max]="200"
        [step]="1"
        class="mt-xs block"
      />
    </div>
  </div>
</form>
